import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { HttpCacheService } from '@core/services/cache.service';
import { CACHE_KEY, CACHE_RESPONSE, CACHE_TTL_MS } from '@core/tokens/http.token';

export function cacheInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	if (req.method !== 'GET') return next(req);
	const cacheService = inject(HttpCacheService);

	const shouldCache = req.context.get(CACHE_RESPONSE);
	if (!shouldCache) return next(req);

	const ttl = req.context.get(CACHE_TTL_MS);
	const ctxKey = req.context.get(CACHE_KEY);
	const key = ctxKey && ctxKey.trim() ? ctxKey : `${req.method} ${req.urlWithParams}`;

	const cached = cacheService.get(key);
	if (cached) return of(cached);

	return next(req).pipe(
		tap(evt => {
			if (evt instanceof HttpResponse) {
				cacheService.set(key, evt, ttl);
			}
		})
	);
}
